export const examAdminAuth = {
  login: {
    pageTitle: "Admin Login",
    documentTitle: "{platformName} · Admin Login",
    shellSubtitle: "AI Exam Admin Portal",
    portalLabel: "Admin Entry",
    title: "Sign in to {platformName}",
    shellDescriptionSso:
      "Prefer unified identity sign-in. If you came from the portal, this page will take over the current session automatically.",
    shellDescriptionHybrid:
      "Unified identity and local account sign-in are both available. Unified identity is recommended.",
    shellDescriptionLocal:
      "This instance currently exposes local sign-in only. Use a local account to enter the admin portal.",
    devAccounts: "Available local accounts: {accounts}",
    maintenanceNotice:
      "The site is under maintenance: the candidate portal is unavailable, but admins can still sign in for maintenance.",
    noPortalAccess: "This account does not have access to the admin portal",
    noResolvedSsoSession: "No usable unified identity session is available",
    captchaRequired: "Please complete the captcha verification first",
    refreshCaptcha: "Refresh captcha",
    ipNotAllowed: "IP is not in allowed range",
    submit: "Sign in",
    authSourceLabel: "Sign-in method",
    authSourceHintHybrid: "Both local and unified identity sign-in are currently supported.",
    authSourceHintSso: "The admin portal has switched to unified identity sign-in.",
    authSourceHintLocal: "This instance currently exposes local sign-in only.",
    bootstrapCheckingTitle: "Checking unified identity sign-in status...",
    bootstrapCheckingDescription:
      "If you entered from the portal, the system will skip this page automatically.",
    currentUnifiedIdentityTitle: "Current Unified Identity",
    currentUnifiedIdentityDescription:
      "After signing in with unified identity, you can enter the admin portal directly.",
    resolvedSsoUserDescription:
      "A current unified identity session was detected and can be used to enter the admin portal quickly.",
    resolvedSsoUsernameLabel: "Unified identity account",
    resolvedSsoRoleLabel: "Role",
    enterWithResolvedSsoUser: "Enter with current identity",
    noResolvedSsoSessionTitle: "No unified identity session detected",
    noResolvedSsoSessionDescription:
      "Please sign in from the portal first, or confirm that the unified identity center is available.",
    openPortal: "Open portal",
    openCandidatePortal: "Open candidate portal",
    highlightUnifiedEntry: "Unified admin entry",
    highlightRoleAccess: "Role-based access control",
    highlightMaintainable: "Maintainable operations",
  },
  changePassword: {
    sectionLabel: "Security Policy",
    title: "Change Login Password",
    description:
      "Account {username} must change the password before continuing to use the admin portal.",
    success: "Password changed successfully",
    mismatch: "The two new passwords do not match",
    newPasswordMustDiffer: "The new password must be different from the current password",
    submit: "Save new password",
    highlightUnifiedShell: "Unified auth shell",
    highlightPolicy: "Password policy enforced",
    highlightSession: "Current session synced",
  },
};
